/* Morpheus GA4 layer — G-DMMCXDJ0HH. CTA events only.
   Shopify's Google & YouTube channel owns config + page_view + ecommerce
   (view_item/add_to_cart/purchase). This file only adds the custom CTA layer,
   so nothing is ever double-counted regardless of script load order.

   It also captures the Google click id (gclid/wbraid/gbraid) and appends it to
   outbound WhatsApp prefills as [G:...], so a conversation that later becomes a
   Closed Won deal in Zoho can be uploaded back to Google Ads as an offline
   conversion. Enhanced conversions for leads CANNOT match these users — they
   never submit a form on the site — so the click id has to travel in the message. */
(function () {
  'use strict';
  if (window.__mphGA4) return;
  window.__mphGA4 = true;
 
  var GA_ID = 'G-DMMCXDJ0HH';
  var DEBUG = /preview_theme_id=/.test(location.search);
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
 
  function send(name, params) {
    try { params = params || {}; if (DEBUG) params.debug_mode = true; window.gtag('event', name, params); }
    catch (e) {}
  }
 
  /* ---- Google click id: capture, persist, carry into WhatsApp ---- */
  var CID_KEY = 'mph_clickid';
  var CID_TTL = 90 * 86400000;            // 90 days — Google's offline import window
 
  (function captureClickId() {
    try {
      var p = new URLSearchParams(location.search);
      // wbraid/gbraid come back instead of gclid on iOS and consent-limited clicks;
      // ignoring them would silently drop a large slice of mobile traffic.
      var g = p.get('gclid') || p.get('wbraid') || p.get('gbraid');
      if (g) localStorage.setItem(CID_KEY, JSON.stringify({ v: g, t: Date.now() }));
    } catch (e) {}
  })();
 
  function clickId() {
    try {
      var r = JSON.parse(localStorage.getItem(CID_KEY) || 'null');
      if (!r || !r.v || (Date.now() - r.t) > CID_TTL) return null;
      return r.v;
    } catch (e) { return null; }
  }
 
  // Appends [G:<clickid>] to the end of the wa.me text param. Deliberately a raw
  // string append rather than URLSearchParams.set, which would re-serialise the
  // whole query and turn existing %20s into '+'. Only appends when text= is the
  // final param (true for every WhatsApp link in this theme and in the Therapy
  // Builder); otherwise it leaves the href alone rather than risk corrupting it.
  function tagWhatsApp(el) {
    try {
      var href = el && el.href;
      if (!href || !/wa\.me|api\.whatsapp\.com/.test(href)) return;
      if (href.indexOf('%5BG%3A') !== -1) return;          // already tagged
      var g = clickId();
      if (!g) return;
      if (/[?&]text=[^&]*$/.test(href)) {
        el.href = href + encodeURIComponent('\n[G:' + g + ']');
      } else if (href.indexOf('?') === -1) {
        el.href = href + '?text=' + encodeURIComponent('[G:' + g + ']');
      }
    } catch (e) {}
  }
 
  // Where an untagged link sits, for the mph_source param. Uses Shopify section
  // groups so topbar/announcement links count as header, not body.
  function zone(el) {
    if (el.closest('.shopify-section-group-header-group, header')) return 'header-nav';
    if (el.closest('.shopify-section-group-footer-group, footer')) return 'footer';
    return 'body';
  }
 
  // CTA click layer — the theme's only job.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest('[data-mph-event]');
    var name = el ? el.getAttribute('data-mph-event') : '';
    var source = el ? el.getAttribute('data-mph-source') : '';
    if (!el) {
      // Fallback: WhatsApp links the sections never tagged (header/footer nav, phone link).
      el = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
      if (!el) return;
      name = 'mph_whatsapp_click';
      source = zone(el);
    }
    // Rewrite the href before the browser follows it, and before link_url is read
    // below, so GA4 records the same URL the user actually opens.
    tagWhatsApp(el);
    send(name, {
      mph_source: source || '',
      link_url: el.href || '',
      link_text: (el.textContent || '').trim().slice(0, 80),
      transport_type: 'beacon'
    });
  }, true);
 
  // Safety net: only if the Google channel never registers a GA4 config (e.g. channel
  // removed) do we add one — with page_view OFF — so CTA events still route, never duplicating.
  var tries = 0;
  (function ensureConfig() {
    for (var i = 0; i < window.dataLayer.length; i++) {
      var d = window.dataLayer[i];
      if (d && typeof d.length === 'number' && d[0] === 'config' && d[1] === GA_ID) return;
    }
    if (tries++ < 60) return setTimeout(ensureConfig, 50);
    var s = document.createElement('script'); s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID; document.head.appendChild(s);
    window.gtag('js', new Date());
    var cfg = { send_page_view: false }; if (DEBUG) cfg.debug_mode = true;
    window.gtag('config', GA_ID, cfg);
  })();
})();